import { render, staticRenderFns } from "./RequestUploadFiles.vue?vue&type=template&id=50af0e32"
import script from "./RequestUploadFiles.vue?vue&type=script&lang=js"
export * from "./RequestUploadFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports